import { useIsLoggedIn } from '@ekonavi/auth';
import { Navigate } from 'react-router-dom';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

// DEV_SKIP_AUTH flag - set to true to bypass authentication during development
const DEV_SKIP_AUTH = import.meta.env.VITE_DEV_SKIP_AUTH === 'true' || false;

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const isLoggedIn = useIsLoggedIn();

  // Skip auth check if DEV_SKIP_AUTH is enabled
  if (DEV_SKIP_AUTH) {
    console.warn('⚠️ DEV_SKIP_AUTH is enabled - authentication is bypassed');
    return <>{children}</>;
  }

  // Not logged in - redirect to login
  // Note: Admin role verification is now done server-side during login
  // If user doesn't have admin role, they won't be able to login from admin origin
  if (!isLoggedIn) {
    return <Navigate to="/auth#login" replace />;
  }

  return <>{children}</>;
}